import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import LeaguesTypeIcon from '../common/LeaguesTypeIcon'
import FaIcon from 'shared/components/fa_icon'
import { setSelectedLeaguesForCloning, selectSelectedLeaguesForCloning } from '../../reducers/selected_leagues_for_cloning'
import { MAX_ALLOWED_LEAGUES_FOR_CLONING } from '../../constants'


const LeaguesBrowserSelectedItems = () => {
  const dispatch = useDispatch()
  const selectedLeagues = useSelector(selectSelectedLeaguesForCloning)
  const removeLeague = (leagueToBeRemoved) =>
    dispatch(setSelectedLeaguesForCloning(selectedLeagues.filter(league => leagueToBeRemoved.id !== league.id)))

  return (
    <div className='cls-lb-si-container'>
      <div className='cls-lb-si-header-container'>
        <span className='cls-view-panel-text'>{window.I18n.t('clone_leagues_sessions.general.selected')}</span>
        <span className='cls-lb-counter-text'>{`${selectedLeagues.length} / ${MAX_ALLOWED_LEAGUES_FOR_CLONING}`}</span>
      </div>
      <div className='cls-lb-si-list'>
        <button
          onClick={() => dispatch(setSelectedLeaguesForCloning([]))}
          className={'cls-lb-si-remove-all'}
        >
          {window.I18n.t('clone_leagues_sessions.leagues_search.remove_all')}
        </button>
        {selectedLeagues.map((league, index) =>
          <span className='cls-lb-si-item' key={league.id}>
            <span className='cls-lb-si-index'>{index + 1}.</span>
            <span className='cls-lb-si-label'>{league.name}</span>
            <LeaguesTypeIcon leagueType={league.product} compact/>
            <span className='cls-lb-si-remove-item' onClick={() => removeLeague(league)}><FaIcon icon='times' /></span>
          </span>,
        )}
      </div>
    </div>)
}

export default LeaguesBrowserSelectedItems
